import { useEffect, useState } from "react";

export function WavingHandEmoji() {
  const [rotation, setRotation] = useState(0);

  const wave = () => {
    const timer1 = setTimeout(() => setRotation(-30), 500);
    const timer2 = setTimeout(() => setRotation(30), 700);
    const timer3 = setTimeout(() => setRotation(-20), 900);
    const timer4 = setTimeout(() => setRotation(20), 1100);
    const timer5 = setTimeout(() => setRotation(0), 1300);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
      clearTimeout(timer5);
    };
  };

  useEffect(() => {
    const cleanup = wave();
    return cleanup;
  }, []);

  return (
    <span
      style={{
        display: "inline-block",
        transform: `rotate(${rotation}deg)`,
        transformOrigin: "bottom right",
        transition: "transform 0.3s ease-out",
        cursor: "none",
      }}
      onMouseEnter={wave}
    >
      👋
    </span>
  );
}
